import { Subscription } from 'rxjs';
import { TreeInputModel } from '../../../@core/models/treeInputModel.entity';

export interface LazyPageEvent {
    first: number;
    rows: number;
}

export interface LazySearchableItem {
    name?: string;
    identification?: string;
}

export class LazyComboState<T extends LazySearchableItem> {
    cachedList: T[] = [];
    cacheKey = '';
    cacheReady = false;
    searchTerm = '';
    searchDebounce: any = null;
    loadInFlight = false;
    cacheCallback: (() => void) | null = null;
    lastRequestId = 0;
    totalRecords = 0;
    pendingSearch = false;
    pageItems: TreeInputModel[] = [];
    subscription: Subscription | null = null;

    isCacheValid(cacheKey: string): boolean {
        return this.cacheReady && this.cacheKey === cacheKey;
    }

    getFilteredList(): T[] {
        const term = this.searchTerm.trim().toLowerCase();
        if (!term) {
            return this.cachedList;
        }

        return this.cachedList.filter((item) => {
            const name = (item.name || '').toLowerCase();
            const identification = (item.identification || '').toLowerCase();
            return name.includes(term) || identification.includes(term);
        });
    }

    reset(): void {
        clearTimeout(this.searchDebounce);
        this.lastRequestId++;

        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }

        this.cachedList = [];
        this.cacheKey = '';
        this.cacheReady = false;
        this.searchTerm = '';
        this.pageItems = [];
        this.totalRecords = 0;
        this.pendingSearch = false;
        this.loadInFlight = false;
        this.cacheCallback = null;
    }

    dispose(): void {
        clearTimeout(this.searchDebounce);

        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
}
